import Box from "@material-ui/core/esm/Box";
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { NavLinkButton } from 'components/Button';
import FlytLogo from 'components/FlytLogo';
import { Title } from 'components/Text';
import useCurrentCustomer from 'hooks/customer/useCurrentCustomer';
import { ACCESS_MANAGEMENT_PATH } from 'routes/AccessManagement/paths';
import { CUSTOMERS, CREATE_CUSTOMER } from 'routes/customers/paths';
import { HOME } from 'routes/home/paths';
import { INVOICES } from 'routes/invoices/paths';
import { AGREEMENTS } from 'routes/overview/paths';
import { PASSINGS_PATH } from 'routes/passings/paths';
import getCustomerName from 'utils/customers/getCustomerName';
import objectHasValues from 'utils/general/objectHasValues';
import useStyles from '../NavigationStyles';
import NavigationProfileMenu from '../ProfileMenu/NavigationProfileMenu';
export default function NavigationNavbar() {
  const {
    t
  } = useTranslation();
  const {
    push
  } = useHistory();
  const {
    customer,
    isBusinessCustomer
  } = useCurrentCustomer();
  let name;
  if (customer && objectHasValues(customer)) {
    name = getCustomerName(customer, isBusinessCustomer);
  }
  const {
    button,
    navigationProfileBox,
    logoBanner,
    navLinks,
    navigationBox,
    logo,
    hidden
  } = useStyles();

  // Hide links on larger devices on customers page
  const matchCustomer = useRouteMatch(CUSTOMERS)?.isExact;
  const matchCreateCustomer = useRouteMatch(CREATE_CUSTOMER)?.isExact;
  const redirectFromTitle = () => matchCreateCustomer || matchCustomer ? push(CUSTOMERS) : push(HOME);
  return /*#__PURE__*/React.createElement(Box, {
    className: navigationBox
  }, /*#__PURE__*/React.createElement("div", {
    className: logoBanner,
    onClick: redirectFromTitle,
    onKeyPress: redirectFromTitle,
    role: "link",
    tabIndex: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: logo
  }, /*#__PURE__*/React.createElement(FlytLogo, null))), /*#__PURE__*/React.createElement(Box, {
    className: clsx(navLinks, {
      [hidden]: matchCustomer || matchCreateCustomer
    })
  }, /*#__PURE__*/React.createElement(NavLinkButton, {
    path: HOME,
    className: button,
    label: t('titles.home')
  }), /*#__PURE__*/React.createElement(NavLinkButton, {
    path: AGREEMENTS,
    className: button,
    label: t('titles.agreements')
  }), /*#__PURE__*/React.createElement(NavLinkButton, {
    path: INVOICES,
    className: button,
    label: t('titles.invoices')
  }), /*#__PURE__*/React.createElement(NavLinkButton, {
    path: PASSINGS_PATH,
    className: button,
    label: t('titles.passings')
  }), /*#__PURE__*/React.createElement(NavLinkButton, {
    path: ACCESS_MANAGEMENT_PATH,
    className: button,
    label: t('titles.access_management')
  })), /*#__PURE__*/React.createElement(Box, {
    className: navigationProfileBox
  }, /*#__PURE__*/React.createElement(Box, {
    mr: 5
  }, /*#__PURE__*/React.createElement(Title, {
    isBold: true,
    className: clsx({
      [hidden]: matchCustomer || matchCreateCustomer
    }),
    align: "right"
  }, customer?.customerNumber && `${t('customers.customer_number')}: ${customer?.customerNumber}`)), /*#__PURE__*/React.createElement(Title, {
    isBold: true,
    className: clsx({
      [hidden]: matchCustomer || matchCreateCustomer
    }),
    align: "right"
  }, name || '\u00A0'), /*#__PURE__*/React.createElement(NavigationProfileMenu, null)));
}